<!-- Landing Inicio del nuevo diseño (ui-redesign). Estilos en home.page.scss + design-system (.ds). -->
<div class="ds app" data-screen-label="Inicio">
	<!-- ===== HERO ===== -->
	<header class="hero wrap">
		<div class="hero-grid">
			<!-- Carrusel del copy (solo este bloque rota; el panel glass y el fondo, no).
			     Autorrotación 7s, pausa en hover, indicadores = navegación, teclado y
			     prefers-reduced-motion (sin autoplay, cambios instantáneos). -->
			<div
				class="hero-copy"
				role="region"
				aria-roledescription="carousel"
				[attr.aria-label]="'home.hero.carouselLabel' | translate"
				(mouseenter)="pauseHero()"
				(mouseleave)="resumeHero()"
			>
				<div
					class="hero-slide"
					[class.is-out]="heroPhase === 'out'"
					[class.is-in]="heroPhase === 'in'"
					role="group"
					aria-roledescription="slide"
					[attr.aria-label]="heroIndex + 1 + ' / ' + heroSlides.length"
					[attr.aria-live]="heroPaused ? 'polite' : 'off'"
				>
					<p class="eyebrow">{{ "home.hero." + heroSlide.key + ".eyebrow" | translate }}</p>
					<h1 [innerHTML]="'home.hero.' + heroSlide.key + '.title' | translate"></h1>
					<p class="lead">{{ "home.hero." + heroSlide.key + ".lead" | translate }}</p>
					<div class="hero-cta">
						<a class="btn btn-primary" [routerLink]="heroSlide.mainLink">
							{{ "home.hero." + heroSlide.key + ".ctaMain" | translate }}
							<span class="ic"><mat-icon>arrow_forward</mat-icon></span>
						</a>
						<a class="btn btn-ghost" [routerLink]="heroSlide.secLink">
							<span class="ic"><mat-icon>{{ heroSlide.secIcon }}</mat-icon></span>
							{{ "home.hero." + heroSlide.key + ".ctaSec" | translate }}
						</a>
					</div>
				</div>
				<!-- OJO: sin la clase global "dots" — su regla `.dots i{width:8px;...}`
				     machacaba la barra de progreso (llenaba 8px, no el pill entero). -->
				<div class="hero-dots" role="tablist" [attr.aria-label]="'home.hero.carouselLabel' | translate" (keydown)="onHeroDotsKeydown($event)">
					<button
						#heroDot
						*ngFor="let s of heroSlides; let i = index"
						type="button"
						class="dot"
						[class.on]="i === heroIndex"
						role="tab"
						[attr.aria-selected]="i === heroIndex"
						[attr.aria-label]="('home.hero.goToSlide' | translate) + ' ' + (i + 1)"
						[tabindex]="i === heroIndex ? 0 : -1"
						(click)="goToSlide(i)"
					>
						<!-- Duración HARDCODEADA en CSS (7s, en fase con HERO_INTERVAL_MS):
						     por binding podía no aplicar y con fill-mode forwards la
						     barra salía llena desde el inicio. -->
					<i
							class="prog"
							*ngIf="i === heroIndex && heroProgVisible && !reducedMotion"
							[class.paused]="heroPaused"
						></i>
					</button>
				</div>
			</div>
			<div class="hero-visual">
				<!-- KPIs del hero = EN CARTERA del usuario (listas scopeadas), a diferencia
				     de la sección "La plataforma en números" (globales sin permisos).
				     Panel ÚNICO glassmorphism sobre la foto de la landing (.landing-bg del
				     layout queda detrás; el backdrop-filter la deja ver difuminada). -->
				<aside class="glass-kpis">
					<div class="gk-item">
						<span class="gk-ic"><mat-icon>description</mat-icon></span>
						<div class="gk-num">{{ contratosUsuarioTotal ?? "—" }}</div>
						<div class="gk-label">{{ "home.kpi.contratos" | translate }}</div>
						<div class="gk-sub">{{ "home.kpi.inPortfolio" | translate }}</div>
					</div>
					<div class="gk-div" aria-hidden="true"></div>
					<div class="gk-item">
						<span class="gk-ic"><mat-icon>apartment</mat-icon></span>
						<div class="gk-num">{{ centrosLoaded ? centros.length : "—" }}</div>
						<div class="gk-label">{{ "home.kpi.centros" | translate }}</div>
						<div class="gk-sub">{{ "home.kpi.inPortfolio" | translate }}</div>
					</div>
				</aside>
				<!-- Medidor de actividad (12 meses de AccesoMensual): OCULTO por ahora
				     (decisión 2026-06-11): la tabla parte vacía y la card se vería sin
				     datos durante meses. El back sigue acumulando; para reactivar,
				     descomentar este bloque (la lógica de actividadBarras sigue viva en el TS).
				<div class="float-card c3" *ngIf="kpis">
					<div class="fc-head">
						<span class="fc-ic"><mat-icon>insights</mat-icon></span>
						{{ "home.activity.title" | translate }}
					</div>
					<div class="act-bars" *ngIf="actividadTotal > 0; else actEmpty">
						<div class="act-bar" *ngFor="let b of actividadBarras; let i = index" [title]="b.label + ': ' + b.count">
							<i [style.height.%]="b.pct < 4 ? 4 : b.pct" [class.zero]="b.count === 0"></i>
							<span>{{ i % 2 === 0 ? b.label : "" }}</span>
						</div>
					</div>
					<ng-template #actEmpty>
						<div class="act-empty">{{ "home.activity.empty" | translate }}</div>
					</ng-template>
					<div class="fc-sub">{{ "home.activity.lead" | translate }}</div>
				</div>
				-->
			</div>
		</div>
	</header>

	<!-- ===== PANEL CENTRAL ===== -->
	<div class="wrap">
		<div class="sheet">
			<!-- ===== Franja "Tu cartera de responsable" (solo responsables; oculta si error/vacío) ===== -->
			<section class="resp-strip" *ngIf="respLoaded && respTotal > 0">
				<span class="rs-badge"><mat-icon>fact_check</mat-icon></span>
				<div class="rs-tx">
					<b>{{ "home.resp.title" | translate }}</b>
					<div class="rs-chips">
						<span class="rs-chip" *ngIf="respContratos.length">
							<mat-icon [inline]="true">description</mat-icon>
							{{ (respContratos.length === 1 ? "home.resp.contrato1" : "home.resp.contratosN") | translate: { n: respContratos.length } }}
						</span>
						<span class="rs-chip" *ngIf="respCentros.length">
							<mat-icon [inline]="true">apartment</mat-icon>
							{{ (respCentros.length === 1 ? "home.resp.centro1" : "home.resp.centrosN") | translate: { n: respCentros.length } }}
						</span>
					</div>
				</div>
				<div class="rs-meter" [ngClass]="respPctClass(respMediaPct)">
					<div class="rs-meter-head">
						<span>{{ "home.resp.media" | translate }}</span>
						<b>{{ respMediaPct }}%</b>
					</div>
					<div class="rs-bar"><i [style.width.%]="respMediaPct"></i></div>
				</div>
				<div class="rs-worst" *ngIf="respPeor">
					<span class="rs-worst-label">{{ "home.resp.peor" | translate }}</span>
					<!-- Chip clicable: tooltip con descripción + tipo, click → ficha de la entidad -->
					<button
						type="button"
						class="rs-worst-chip"
						[matTooltip]="respPeorTooltip"
						(click)="goToRespPeor()"
					>
						<mat-icon [inline]="true">{{ respPeorInfo?.esCentro ? "apartment" : "description" }}</mat-icon>
						<span class="rs-worst-code">{{ respPeor.codigo }}</span>
						<b [ngClass]="respPctClass(respPeor.cumplimentacion.porcentaje)">{{ respPeor.cumplimentacion.porcentaje }}%</b>
					</button>
				</div>
				<a class="btn btn-primary" routerLink="/my-responsibilities">
					{{ "home.resp.cta" | translate }}
					<span class="ic"><mat-icon>arrow_forward</mat-icon></span>
				</a>
			</section>

			<!-- ===== PANEL 1: Accesos rápidos (Tus centros + Contratos activos) ===== -->
			<section class="dashboard-panel quick-access-panel">
				<p class="overline panel-label">{{ "home.quickAccess" | translate }}</p>

				<!-- Subsección: Tus centros -->
				<div class="block-head">
					<div class="ttl">
						<h2 class="h-section">{{ "home.recentCentros" | translate }}</h2>
					</div>
					<a class="link-more" routerLink="/sites">
						{{ "home.seeAll" | translate }} <span class="ic"><mat-icon>arrow_forward</mat-icon></span>
					</a>
				</div>
				<div class="centers-row">
					<article class="center-card" *ngFor="let c of centros | slice : 0 : 5">
						<div class="cc-img">
							<!-- Imagen efectiva: la del centro o, en su defecto, la del contrato.
							     Sin ninguna de las dos → degradado default (coherente con los covers). -->
							<img class="cc-photo" *ngIf="centroImg[c.id]" [src]="centroImg[c.id]" alt="" />
							<div class="cc-grad" *ngIf="!centroImg[c.id]"></div>
							<span class="cc-badge"><mat-icon>apartment</mat-icon></span>
						</div>
						<div class="cc-body">
							<div class="cc-name">{{ c.descripcion || c.codigo }}</div>
							<div class="cc-meta">{{ c.codigo }}</div>
							<div class="recent-stamp" *ngIf="centroLastAccess[c.id]"><mat-icon>schedule</mat-icon>{{ relativeAccess(centroLastAccess[c.id]) }}</div>
							<div class="cc-foot">
								<span class="cc-loc"><span class="ic"><mat-icon>place</mat-icon></span> {{ c.ciudad || c.provincia || c.pais }}</span>
								<a class="round-btn" [routerLink]="['/sites', c.id]"><span class="ic"><mat-icon>arrow_forward</mat-icon></span></a>
							</div>
						</div>
					</article>
					<!-- Huecos fantasma hasta completar 5 (usuarios con 1-2 centros) -->
					<article class="center-card ghost" *ngFor="let g of ghostSlots" aria-hidden="true">
						<div class="cc-img">
							<span class="cc-badge ghost-badge"><mat-icon>apartment</mat-icon></span>
						</div>
						<div class="cc-body">
							<div class="cc-ghost-line w60"></div>
							<div class="cc-ghost-line w40"></div>
							<div class="cc-foot">
								<span class="cc-ghost-label">{{ "home.ghost" | translate }}</span>
							</div>
						</div>
					</article>
					<div class="centers-empty" *ngIf="centrosLoaded && !centros?.length && !ghostSlots.length">{{ "home.noData" | translate }}</div>
				</div>

				<!-- Subsección: Contratos activos (tabla, top N) -->
				<div class="block-head sub-head">
					<div class="ttl">
						<h2 class="h-section">{{ "home.contractsActive" | translate }}</h2>
					</div>
					<a class="link-more" routerLink="/contracts">{{ "home.seeAll" | translate }} <span class="ic"><mat-icon>arrow_forward</mat-icon></span></a>
				</div>
				<div class="table-card opx-table">
					<table class="ctr" [(dsSortTable)]="contracts">
						<thead>
							<tr>
								<th data-sort="descripcion">{{ "lst.col.name" | translate }}</th>
								<th data-sort="codigo">{{ "lst.col.code" | translate }}</th>
								<th data-sort="sociedad">{{ "home.col.client" | translate }}</th>
								<th data-sort="pais">{{ "home.col.country" | translate }}</th>
								<th data-sort="tipoProyecto">{{ "home.col.type" | translate }}</th>
								<th data-sort="responsableNombre">{{ "home.col.responsable" | translate }}</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let c of contracts | slice : 0 : 6" [routerLink]="['/contracts', c.id]">
								<td><div class="name-stack"><span class="opx-name">{{ c.descripcion || c.codigo }}</span><span class="recent-stamp" *ngIf="contractLastAccess[c.id]"><mat-icon>schedule</mat-icon>{{ relativeAccess(contractLastAccess[c.id]) }}</span></div></td>
								<td><span class="code">{{ c.codigo }}</span></td>
								<td class="cli">{{ c.sociedad || "—" }}</td>
								<td><app-country [name]="c.pais" [iso2]="c.codigoIso2Pais"></app-country></td>
								<td>{{ c.tipoProyecto || c.actividad || "—" }}</td>
								<td>
									<span class="resp">
										<app-empleado-avatar size="sm" [empleado]="respEmpleado(c)"></app-empleado-avatar>
										<span class="resp-name">{{ respNombre(c) }}</span>
									</span>
								</td>
								<td><span class="opx-go ic"><mat-icon>chevron_right</mat-icon></span></td>
							</tr>
							<tr *ngIf="!contracts?.length">
								<td colspan="7" style="text-align: center; color: var(--ink-3)">{{ "home.noData" | translate }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<!-- ===== PANEL 2: Visión global (métricas + mapa), encajado bajo el panel 1 ===== -->
			<section class="dashboard-panel overview-panel">
				<p class="overline panel-label">{{ "home.platform.overline" | translate }}</p>
				<h2 class="h-section">{{ "home.platform.title" | translate }}</h2>
				<!-- KPIs GLOBALES sin permisos (GET /Home/Kpis) -->
				<div class="kpi-bar platform">
					<div class="kpi">
						<div class="kpi-h"><span class="kpi-ic"><mat-icon>description</mat-icon></span> {{ "home.kpi.contratos" | translate }}</div>
						<div class="kpi-row"><div class="kpi-big">{{ kpis ? kpis.contratos : "—" }}</div></div>
						<div class="kpi-sub">{{ "home.kpi.registered" | translate }}</div>
					</div>
					<div class="kpi">
						<div class="kpi-h"><span class="kpi-ic"><mat-icon>apartment</mat-icon></span> {{ "home.kpi.centros" | translate }}</div>
						<div class="kpi-row"><div class="kpi-big">{{ kpis ? kpis.centros : "—" }}</div></div>
						<div class="kpi-sub">{{ "home.kpi.registered" | translate }}</div>
					</div>
					<div class="kpi">
						<div class="kpi-h"><span class="kpi-ic"><mat-icon>category</mat-icon></span> {{ "home.kpi.actividades" | translate }}</div>
						<div class="kpi-row"><div class="kpi-big">{{ kpis ? kpis.actividades : "—" }}</div></div>
						<div class="kpi-sub">{{ "home.kpi.distinct" | translate }}</div>
					</div>
					<div class="kpi">
						<div class="kpi-h"><span class="kpi-ic"><mat-icon>public</mat-icon></span> {{ "home.kpi.paises" | translate }}</div>
						<div class="kpi-row"><div class="kpi-big">{{ kpis ? kpis.paises : "—" }}</div></div>
						<div class="kpi-sub">{{ "home.kpi.activeCountries" | translate }}</div>
					</div>
					<div class="kpi">
						<div class="kpi-h"><span class="kpi-ic"><mat-icon>map</mat-icon></span> {{ "home.kpi.mapa" | translate }}</div>
						<div class="kpi-row"><div class="kpi-big" style="font-size: 17px">{{ "home.kpi.explore" | translate }}</div></div>
						<div class="kpi-sub">{{ "home.kpi.interactiveMap" | translate }}</div>
					</div>
					<a class="kpi-map" routerLink="/map" aria-label="{{ 'home.map.open' | translate }}">
						<div class="dotmap"></div>
						<span class="round-btn"><span class="ic"><mat-icon>arrow_forward</mat-icon></span></span>
					</a>
				</div>

				<!-- Mapa grande (CTA) — dentro del panel Visión global -->
				<div class="mapblock">
					<div>
						<p class="overline">{{ "home.map.eyebrow" | translate }}</p>
						<h2>{{ "home.map.title" | translate }}</h2>
						<p>{{ "home.map.lead" | translate }}</p>
						<a class="btn btn-ghost" routerLink="/map"><span class="ic"><mat-icon>open_in_new</mat-icon></span> {{ "home.map.open" | translate }}</a>
					</div>
					<a class="bigmap" routerLink="/map" aria-label="{{ 'home.map.open' | translate }}">
						<div #miniMapEl class="mini-map"></div>
						<div class="bigmap-cta"><mat-icon>open_in_new</mat-icon></div>
					</a>
				</div>
			</section>
		</div>

		<!-- Soporte -->
		<div class="support" style="margin-top: 20px">
			<span class="s-ic"><mat-icon>headset_mic</mat-icon></span>
			<div class="s-tx">
				<b>{{ "home.support.title" | translate }}</b>
				<span>{{ "home.support.lead" | translate }}</span>
			</div>
			<a class="btn btn-dark" href="javascript:void(0)">{{ "home.support.cta" | translate }} <span class="ic"><mat-icon>arrow_forward</mat-icon></span></a>
		</div>
	</div>
</div>
